module.exports = __webpack_public_path__ + "img/radio.462ebfdb.png";